export enum CurtainTabsEnum {
  COLLABORATION_TAB = 'COLLABORATION_TAB',
  CART_TAB = 'CART_TAB',
  DETAILS_TAB = 'DETAILS_TAB',
  WORKABLES_TAB = 'WORKABLES_TAB',
  STYLE_DETAILS_TAB = 'STYLE_DETAILS_TAB',
  HINTS = 'HINTS',
  ORDER_CHANGE_LOG = 'ORDER_CHANGE_LOG',
  ACK_CHANGE_LOG = 'ACK_CHANGE_LOG',
  DEALERSHIP_PREFERENCES = 'DEALERSHIP_PREFERENCES',
}
